if (!customElements.get("contact-form")) {
    customElements.define(
        'contact-form',
        class ContactForm extends HTMLElement {
            constructor() {
                super();
                const seft = this;
                this.imageCard = this.querySelector('.contact-form-image-card-container');
                this.textCard = this.querySelector('.contact-form-text-card');
                this.imageCardContent = this.querySelector('.image-card-content');
                this.textCardContent = this.querySelector('.text-card-content');
                this.submitButton = this.querySelector('button[type="submit"]');
                this.init();

                if (this.submitButton) {
                    this.submitButton.addEventListener('click', this.onSubmitForm.bind(this));
                }

                document.addEventListener('shopify:section:load', function (event) {
                    seft.init();
                    QueryParams.removeQueryParams(['contact_posted', ['pb']]);
                });

                window.addEventListener('resize', () => {
                    seft.init();
                });
            }

            init () {
                const imageCardHeight = this.imageCard?.clientHeight || 0;
                const textCardHeight = this.textCard?.clientHeight || 0;
                const imageCardContentHeight = (this.imageCardContent?.clientHeight || 0) + 100;
                const textCardContentHeight = (this.textCardContent?.clientHeight || 0) + 100;
                const heightMax = Math.max(...[imageCardHeight, textCardHeight, imageCardContentHeight, textCardContentHeight]) || 350;
                
                this.style.setProperty('--card-min-height', `${heightMax}px`);
            }

            onSubmitForm(e) {
                const target = e.target;
                const checkboxInputs = this.querySelectorAll('.form__field-checkbox');
                checkboxInputs.forEach(input => {
                    const formGroup = input.closest('.form__groups-checkbox');
                    const error = input.hasAttribute('required') && !input.checked ? true : false;
                    if (error) {
                        input.focus();
                        input.reportValidity();
                        formGroup.classList.add('error');
                    } else {
                        formGroup.classList.remove('error');
                    }
                });

                const radioGroups = this.querySelectorAll('.form__groups-radio');
                radioGroups.forEach(formGroup => {
                    const input = formGroup.querySelector('input');
                    const selectedRadio = formGroup.querySelector('input:checked');
                    const error = input.hasAttribute('required') && !selectedRadio ? true : false;
                    if (error) {
                        formGroup.classList.add('error');
                    } else {
                        formGroup.classList.remove('error');
                    }
                });
            }
        }
    );
}